import { z } from 'zod'
import { l } from '@manychat/manyui'

import { MAX_FIELDS_COUNT } from './constants'

export const configFormSchema = z.object({
  context: z
    .string()
    .min(1, l.translate('Enter context to continue'))
    .max(500, l.translate('Context must be {count} characters or fewer', { count: 500 })),
  fields: z
    .array(
      z.object({
        fieldId: z.string(),
      }),
    )
    .min(1, l.translate('Add a field to collect'))
    .max(
      MAX_FIELDS_COUNT,
      l.translate("You can't add more than {count} fields", {
        count: MAX_FIELDS_COUNT,
      }),
    ),
  assignee: z.object({
    user_id: z.number().nullable(),
    group_id: z.number().nullable(),
  }),
  useWaId: z.boolean(),
})
